<template>
    <section class="home-container">
        <MasterPage title="微信推送">
            <div slot="title-icon">
                <Icon type="ios-chatbubbles" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="24">
                        <FormItem label="推送标题：">
                            <Input v-model="select.title" placeholder="请输入" />
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true" style="margin-right: 10px">添加</Button>
                <Button type="info" icon="md-albums" @click="sendModel=true">发布</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增微信推送" width="1200" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem label="推送标题：">
                        <Input v-model="itemAdd.title" placeholder="请输入" />
                    </FormItem>
                    <FormItem label="推送摘要：">
                        <Input v-model="itemAdd.digest" type="textarea" :autosize="{minRows: 4,maxRows: 6}" placeholder="请输入" />
                        <div class="my_font">
                            <span style="padding-right: 15px">仅单图文推送显示摘要</span>
                        </div>
                    </FormItem>
                    <FormItem label="推送内容：">
                        <div id="weixinEditor"></div>
                        <div class="my_font">
                            <span style="padding-right: 15px">内容请勿超过2万字</span>
                        </div>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="封面图片：">
                        <Upload
                                ref="thumbMediaImage"
                                multiple
                                type="drag"
                                :format="['jpg','jpeg','png']"
                                accept="image/*"
                                :before-upload="fileFrontImageBefore"
                                :on-success="fileFrontImageSuccess"
                                :on-error="fileError"
                                action="food/file/upload">
                            <div style="padding:35px 0;background-size: contain;background-position : center;background-repeat: no-repeat" :style="{backgroundImage: 'url(\'' + itemAdd.thumbPictureUrl + '\')'}">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>单击或拖动图片以上传</p>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="显示封面：">
                        <i-switch v-model="itemAdd.showCoverPic" size="large">
                            <span slot="open">显示</span>
                            <span slot="close">隐藏</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="推送作者：">
                        <Input v-model="itemAdd.author" placeholder="请输入" />
                    </FormItem>
                    <FormItem label="原文地址：">
                        <Input v-model="itemAdd.contentSourceUrl" placeholder="http://" />
                    </FormItem>
                    <FormItem label="开启评论：">
                        <i-switch v-model="itemAdd.needOpenComment" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                        <div class="my_font">
                            <span style="padding-right: 15px">（建议关闭）</span>
                            <span style="padding-right: 15px">开启：可以对推送文章进行评论</span>
                            <span style="padding-right: 15px">关闭：无法对推送文章进行评论</span>
                        </div>
                    </FormItem>
                    <FormItem v-show="itemAdd.needOpenComment == true" label="评论限制：">
                        <i-switch v-model="itemAdd.onlyFansCanComment" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                        <div class="my_font">
                            <span style="padding-right: 15px">（建议开启）</span>
                            <span style="padding-right: 15px">开启：仅粉丝可以进行评论</span>
                            <span style="padding-right: 15px">关闭：所有人均可以进行评论</span>
                        </div>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="previewMessageToUserModel" title="推送预览"  @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="微信号：">
                    <Input v-model="previewMessageToUserInfo.mediaId" placeholder="请输入" />
                </FormItem>
                <p style="color: #c3c3c3;padding-left: 100px">推送预览只能推送给单用户，每次推送次数不限</p>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="previewMessageToUserLoading" @click="sendToPreviewMessageToUser">确定</Button>
            </div>
        </Modal>
        <Modal v-model="sendModel" title="发送推送" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="推送消息：">
                    <Select v-model="sendMediaIdList" multiple  placeholder="请选择">
                        <Option v-for="item in dataList" :value="item.media_id" :key="item.id">
                            {{ item.title }}
                        </Option>
                    </Select>
                </FormItem>
                <p style="color: #c3c3c3;padding-left: 100px">推送给所有用户，每天只能推送一次，可推送多条</p>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="sendLoading" @click="sendItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" width="750" title="推送消息详情">
            <Row>
                <Col span="12">
                <div class="info_backgroup">
                    <div v-html="infoItem.content" class="info_html"></div>
                </div>
                </Col>
                <Form :label-width="100">
                    <Col span="12">
                    <FormItem label="推送标题：">
                        {{infoItem.title}}
                    </FormItem>
                    <FormItem label="推送摘要：">
                        {{infoItem.digest}}
                    </FormItem>
                    <FormItem label="封面图片：">
                        <img :src="infoItem.thumbPictureUrl" style="max-width: 100%">
                    </FormItem>
                    <FormItem label="显示封面：">
                        <i-switch v-model="infoItem.show_cover_pic == '0'?false:true" :disabled="true" size="large">
                            <span slot="open">显示</span>
                            <span slot="close">隐藏</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="推送作者：">
                        {{infoItem.author}}
                    </FormItem>
                    <FormItem label="原文地址：">
                        {{infoItem.content_source_url}}
                    </FormItem>
                    <FormItem label="开启评论：">
                        <i-switch v-model="infoItem.need_open_comment == '0'?false:true" :disabled="true" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem v-if="infoItem.needOpenComment == '1'" label="评论限制：">
                        <i-switch v-model="itemAdd.only_fans_can_comment == '0'?false:true" :disabled="true" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="创建时间：">
                        {{infoItem.operateTime | dateTimeToString}}
                    </FormItem>
                    </Col>
                </Form>
            </Row>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    var E = require('wangeditor')
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '推送标题',
                        align:'center',
                        key: 'title',
                        tooltip:true,
                    },
                    {
                        title: '作者',
                        key: 'author',
                        ellipsis: true,
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value = params.row.operateTime
                            if (value == null || value == '') return string
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hh = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span',y+'-'+m+'-'+d+' '+hh+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-aperture',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.sendToPreviewMessageToUser_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '预览')
                            ]
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                previewMessageToUserModel:false,
                previewMessageToUserLoading:false,
                sendModel:false,
                sendLoading:false,
                infoModel:false,
                select:{
                    title:'',
                },
                itemAdd:{
                    title:'',
                    thumbPictureUrl:'',
                    thumbMediaId:'',
                    author:'',
                    digest:'',
                    showCoverPic:true,
                    content:'',
                    befor:'http:',
                    contentSourceUrl:'',
                    needOpenComment:false,
                    onlyFansCanComment:true,
                    pictureUrl:[],
                },
                infoItem:'',
                previewMessageToUserInfo:{
                    id:'',
                    weinXinUser:'',
                },
                sendMediaIdList:[],
                editor:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        mounted(){
            let menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'strikeThrough',  // 删除线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'list',  // 列表
                'justify',  // 对齐方式
                'quote',  // 引用
                'image',  // 插入图片
                'undo',  // 撤销
                'redo'  // 重复
            ]
            if (this.editor == ''){
                let editor = new E('#weixinEditor')
                editor.customConfig.menus = menus
                editor.customConfig.uploadImgMaxSize = 64 * 1024
                editor.customConfig.uploadImgServer = '/food/file/upload'
                editor.customConfig.uploadFileName = 'file'
                editor.customConfig.showLinkImg = false
                editor.customConfig.uploadImgHooks = {
                    customInsert: (insertImg, result, editor) => {
                        let imageUrl = result.data
                        this.fileContentImage(imageUrl,insertImg)
                    }
                }
                editor.create()
                this.editor = editor
            }
        },
        methods:{
            fileFrontImageBefore(file){
                this.$refs.thumbMediaImage.clearFiles()
                if (file.type != 'image/jpeg' && file.type != 'image/png' ) {
                    this.$Message.warning('只能上传jpg或png图片文件');
                    return false
                }
                if (file.size > 65536) {
                    this.$Message.warning('图片大小请勿超过64kb');
                    return false
                }
                return true
            },
            fileFrontImageSuccess(response){
                this.$http.post('weiXin/addFrontImage',{
                    filePath:response.data,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.itemAdd.thumbPictureUrl = response.data.replace(/\\/g,"/")
                        this.itemAdd.thumbMediaId = msg.data.wxMediaId
                        this.$Notice.success({title:'封面图片上传成功'});
                    }else {
                        this.$Notice.error({title:'封面图片上传失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            fileContentImage(filePath,insertImg){
                this.$http.post('weiXin/addContentImage',{
                    filePath:filePath,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title:'图片添加成功'});
                        insertImg(filePath.replace(/\\/g,"/"))
                        this.itemAdd.pictureUrl.push({wxURL:msg.data.wxUrl,imgUrl:filePath.replace(/\\/g,"/")})
                    }else {
                        this.$Notice.error({title:'图片添加失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            fileError(error){
                this.$Notice.error({title:'图片上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('weiXin/list',{
                    title:this.select.title,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'推送列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                this.itemAdd.content = this.editor.txt.html()
                if (this.itemAdd.title.length <= 0){
                    return this.$Message.warning('请输入推送标题');
                }
                if (this.itemAdd.digest.length <= 0){
                    return this.$Message.warning('请输入推送摘要');
                }
                if (this.itemAdd.content.length <= 0){
                    return this.$Message.warning('请输入推送内容');
                }
                if (this.itemAdd.content.length > 20000){
                    return this.$Message.warning('推送内容请勿超过2万字');
                }
                if (this.itemAdd.thumbMediaId.length <= 0){
                    return this.$Message.warning('请上传封面图片');
                }
                if (this.itemAdd.thumbPictureUrl.length <= 0){
                    return this.$Message.warning('请上传封面图片');
                }
                if (this.itemAdd.author.length <= 0){
                    return this.$Message.warning('请输入作者名称');
                }
                if (this.itemAdd.contentSourceUrl.length <= 0){
                    return this.$Message.warning('请输入推送原文地址');
                }
                this.addLoading = true
                this.itemAdd.pictureUrl.forEach((item)=>{
                    this.itemAdd.content = this.itemAdd.content.replace(new RegExp(item.imgUrl,'g'),item.wxURL)
                })
                this.$http.post('weiXin/uploadMessage',{
                    title:this.itemAdd.title,
                    thumbMediaId:this.itemAdd.thumbMediaId,
                    thumbPictureUrl:this.itemAdd.thumbPictureUrl,
                    author:this.itemAdd.author,
                    digest:this.itemAdd.digest,
                    showCoverPic:this.itemAdd.showCoverPic?1:0,
                    content:this.itemAdd.content,
                    contentSourceUrl:this.itemAdd.contentSourceUrl,
                    needOpenComment:this.itemAdd.needOpenComment?1:0,
                    onlyFansCanComment:this.itemAdd.onlyFansCanComment?1:0,
                    pictureUrl:this.itemAdd.pictureUrl.length > 0 ? JSON.stringify(this.itemAdd.pictureUrl) : null,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '微信推送新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'微信推送新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            sendToPreviewMessageToUser_modal(item){
                this.previewMessageToUserInfo.weinXinUser = ''
                this.previewMessageToUserInfo.id = item.id
                this.previewMessageToUserModel = true
            },
            sendToPreviewMessageToUser(){
                if (this.previewMessageToUserInfo.id.toString().length <= 0 ){
                    return this.$Message.warning('数据异常')
                }
                // if (this.previewMessageToUserInfo.weinXinUser.length <= 0 ){
                //     return this.$Message.warning('请输入预览者的微信号')
                // }
                this.previewMessageToUserLoading = true
                this.$http.post('weiXin/sendToPreviewMessageToUser',{
                    mediaId:this.previewMessageToUserInfo.id
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.infoItem = msg.data
                        this.$Notice.success({title: '推送消息预览成功'});
                    }else {
                        this.$Notice.error({title:'推送消息预览失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            sendItem(){
                if (this.sendMediaIdList.length <= 0 ){
                    return this.$Message.warning('请选择推送')
                }
                this.sendLoading = true
                this.$http.post('weiXin/sendMessageToAll',{
                    mediaId:this.sendMediaIdList[0],
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '推送消息发送成功'});
                    }else {
                        this.$Notice.error({title:'推送消息发送失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.previewMessageToUserModel = this.previewMessageToUserLoading = this.sendModel = this.sendLoading = this.infoModel =  false
                this.editor.txt.clear()
                this.$refs.thumbMediaImage.clearFiles()
                this.itemAdd = {
                    title:'',
                    thumbPictureUrl:'',
                    thumbMediaId:'',
                    author:'',
                    digest:'',
                    showCoverPic:true,
                    content:'',
                    befor:'http:',
                    contentSourceUrl:'',
                    needOpenComment:false,
                    onlyFansCanComment:true,
                    pictureUrl:[],
                }
                this.sendMediaIdList = []
            },
            infoItem_modal(item){
                this.infoItem = JSON.parse(JSON.stringify(item))
                if (this.infoItem.pictureUrl){
                    let pictureUrl = JSON.parse(this.infoItem.pictureUrl)
                    pictureUrl.forEach((item)=>{
                        this.infoItem.content = this.infoItem.content.replace(new RegExp(item.wxURL,'g'),item.imgUrl)
                    })
                }
                this.infoModel = true
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }

    .my_font{
        font-size: 12px;
        color: #AFAFAF;
    }

    .info_backgroup{
        background-image: url('../../assets/image/phone.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        height: 630px;
        padding: 80px 45px 85px 50px;
    }

    .info_html{
        max-height:465px;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-right: 5px;
    }

    .info_html >>> img{
        max-width: 100%;
    }

    .info_html::-webkit-scrollbar {
        width: 4px;
    }
    .info_html::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .info_html::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
</style>
